import {Fragment, observer, React } from "@api"
import { MenuDivider } from "@blueprintjs/core"
import {Stop} from '@material-ui/icons'
import {BoardFilterGroup, ContextMenuItem, DefaultCatalogContextMenuItems, useFilterChipStore} from '@modules'
import {SearchFilterGroup} from '@modules/catalog/internal/filters/components/internal'
import {useCatalog} from '@stores'
import {icons} from '@stores/ui'
import {toJS} from 'mobx'
import * as css from './FilterChipContextMenu.css'

export const FilterChipContextMenu = observer(function FilterChipContextMenu() {
  const {title, group, field, onClear, filter, clearOtherFilters} = useFilterChipStore(),
    {filtersWithSelections} = filter,
    {labelForField} = useCatalog(),
    label = labelForField(field),
    {items, selected, excluded} = filter.stateFor(field)

  console.log(toJS(items))
  return <Fragment>
    <ContextMenuItem icon='filter' text={label} noSubmenuPadding>
      <SearchFilterGroup noSectionDropdown/>
      <BoardFilterGroup className={css.filterGroup} field={field} ignoreSection ignoreSearch/>
      {/*<ContextMenuItem icon={<Stop/>} text={`Stop Filtering '${label}'`} onClick={onClear}/>
      {!_.isEmpty(items) && <Fragment>
	      <MenuDivider/>
        <BoardFilterGroup field={field} />
      </Fragment>}*/}
    </ContextMenuItem>
    <ContextMenuItem text={`Clear All Filters`} icon={'trash'} onClick={filter.resetFilterExcludeSeason}/>
    {filtersWithSelections.length > 1 && <ContextMenuItem icon={icons.clear} text='Clear Other Filters' onClick={clearOtherFilters} />}
    <MenuDivider />
    <DefaultCatalogContextMenuItems />
  </Fragment>
})


// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/FilterChipContextMenu.tsx